import { css } from '@/styled-system/css';

// Vertical stack with consistent gap between FormField elements inside <form>.
// A plain <form> has no inherent spacing; Constellation's FormField provides
// label + control + help text within each field but not between fields.
export const form = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});
